import { Injectable } from '@angular/core';

import { config } from '../../../../config';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../../services';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ReportService {
  constructor(private token: TokenService, private http: HttpClient) {
  }

  /**
   * Download the debt report
   *
   * @param string client_id
   * @return {Observable<string>}
   */
  debtReportUrl(client_id: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/client/${client_id}/cases?token=${token}`);
  }

  /**
   * Download the receivable report
   *
   * @param string start_date
   * @param string end_date
   * @return {Observable<string>}
   */
  receviableReportUrl(start_date: string, end_date: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/receivable?token=${token}&start_date=${start_date}&end_date=${end_date}`);
  }

  /**
   * Download the system statistics report
   *
   * @return {Observable<string>}
   */
  downloadSystemStatisticsUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/system-statistics?token=${token}`);
  }

  /**
   * Download the trust payables report
   *
   * @return {Observable<string>}
   */
  downloadMonthlySystemStatisticsUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/monthly-system-statistics?token=${token}&months=6`);
  }

  /**
   * Download the trust payables report
   *
   * @return {Observable<string>}
   */
  trustPayablesReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/trust-payables?token=${token}`);
  }

  /**
   * Download the clients without bank details report
   *
   * @return {Observable<string>}
   */
  downloadClientsWithoutBankDetailsReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/clients-without-bank-details?token=${token}`);
  }

  /**
   * Download the deposits in transit report
   *
   * @return {Observable<string>}
   */
  downloadDepositsInTransitReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/deposits-in-transit?token=${token}`);
  }

  /**
   * Download the adhoc transactions report
   *
   * @return {Observable<string>}
   */
  downloadAdhocTransactionsReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/adhoc-transactions?token=${token}`);
  }

  downloadCasesReportUrl(): Observable<any> {
      return this.http
        .get(`${config.apiLocation}/v1/reports/cases`);
  }

  /**
   * Download the tax invoices report
   *
   * @return {Observable<string>}
   */
  downloadTaxInvoicesReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/tax-invoices?token=${token}`);
  }

  /**
   * Download the liability report
   *
   * @return {Observable<string>}
   */
  downloadLiabilityReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/liability?token=${token}`);
  }

  /**
   * Download the primary phase collections report
   *
   * @return {Observable<string>}
   */
  downloadPrimaryPhaseCollectionsReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/primary-phase-collections?token=${token}`);
  }

  /**
   * Download the client payment report
   *
   * @return {Observable<string>}
   */
  downloadclientPaymentReportUrl(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/client-payments?token=${token}`);
  }

  /**
   * Download the payment plans report
   *
   * @return {Observable<string>}
   */
  downloadPaymentPlansReport(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/payment-plans?token=${token}`);
  }

  /**
   * Download the payment status report
   *
   * @return {Observable<string>}
   */
  downloadPaymentStatusReport(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/payment-status?token=${token}`);
  }

  /**
   * For Panthera Finance, download all payment objects on a case in BillChaser Report.
   *
   * @return {Observable<string>}
   */
  downloadPaymentReceiptsReport(): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/reports/payment-receipts?token=${token}`);
  }

  downloadInternalPerformanceReport(): Observable<any> {
    return this.http
      .get(`${config.apiLocation}/v1/reports/internal-performance-report`);
  }

  downloadBillChaserReviewsReport(): Observable<any> {
    return this.http
      .get(`${config.apiLocation}/v1/reports/billchaser-reviews-report`);
  }

  downloadClientPaymentReport(): Observable<any> {
    return this.http
      .get(`${config.apiLocation}/v1/reports/in-client-payment-status`);
  }

  downloadAwaitingClientReportUrl(): Observable<any> {
    return this.http
      .get(`${config.apiLocation}/v1/reports/awaiting-client-status-report`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/reports/report.service.ts